module.exports = __webpack_public_path__ + "static/media/reference-slider-24.196a3f0f.jpg";